<div class="w-100 hit-box-placement bg-login">
  <div class="login mt-0 box-bg form-padding max450w">
    <!-- <ngx-loading [show]="loading"></ngx-loading> -->
    <div class="login-title primary-header">Login</div>
    <div class="login-title-msg mb-3">Welcome to iDEC Face</div>
    <div class="floating-form" [formGroup]="loginForm">
      <div class="d-flex justify-content-center  align-items-center w-100 h-100">
        <div class="loaderSvg d-flex align-items-center justify-content-center">
        </div>
      </div>
      <div class="d-flex flex-column ">
        <div class="mt-top-2 field">
          <mat-form-field class="field">
            <mat-label>Organisation</mat-label>
            <input matInput oninput="this.value = this.value.toUpperCase()" placeholder="Organisation"
              (keyup.enter)="login()" formControlName="domain">
            <ng-container *ngIf="loginSubmitted && loginFormValues['domain'].errors">
              <mat-error *ngIf="loginFormValues['domain'].errors?.['required']">
                <em class="fas fa-exclamation-circle mr-2"></em>Organisation is required
              </mat-error>
              <mat-error *ngIf="loginFormValues['domain'].errors?.['pattern']">
                <em class="fas fa-exclamation-circle mr-2"></em>Remove white space from start and
                end
              </mat-error>
            </ng-container>
          </mat-form-field>
        </div>
        <div class="mt-top-2 field">
          <mat-form-field>
            <mat-label>Username</mat-label>
            <input matInput placeholder="Username" (keyup.enter)="login()" formControlName="username">
            <ng-container *ngIf="loginSubmitted && loginFormValues['username'].errors">
              <mat-error *ngIf="loginFormValues['username'].errors?.['required']">
                <em class="fas fa-exclamation-circle mr-2"></em>Username is required
              </mat-error>
              <mat-error *ngIf="loginFormValues['username'].errors?.['pattern']">
                <em class="fas fa-exclamation-circle mr-2"></em>Remove white space from start and
                end
              </mat-error>
            </ng-container>
          </mat-form-field>
        </div>
        <div class="mt-top-2 field">
          <mat-form-field>
            <mat-label>Password</mat-label>
            <input matInput placeholder="Password" [type]="confirmHide ? 'password' : 'text'" (keyup.enter)="login()"
              formControlName="password" autocomplete="new-password">
            <button mat-icon-button matSuffix (click)="confirmHide = !confirmHide" [attr.aria-label]="'Hide password'"
              [attr.aria-pressed]="confirmHide">
              <mat-icon>{{confirmHide ? 'visibility_off' : 'visibility'}}</mat-icon>
            </button>
            <ng-container *ngIf="loginSubmitted && loginFormValues['password'].errors">
              <mat-error *ngIf="loginFormValues['password'].errors?.['required']">
                <em class="fas fa-exclamation-circle mr-2"></em>Password is required
              </mat-error>
            </ng-container>
          </mat-form-field>
        </div>
        <div class="d-flex justify-content-center">
          <div class="err-mssg-domain text-danger mb-2" *ngIf="errorMessage"><em
              class="fas fa-exclamation-circle mr-2"></em>{{errorMessage}}</div>
        </div>
 
        <div class="btn-basket">
          <button mat-raised-button class="col-2" color="primary" (click)="login()">
            Login
          </button>
        </div>
        <div class="d-flex justify-content-center"><label class="cursor text-underline linkStyle"
            (click)="loadForgotPasswordForm()"><u>Forgot
              Password?</u></label></div>
      </div>
    </div>
 
    <div class="d-flex justify-content-center">
      <div class="linkStyle mt-2 ft-12">Don't have an account? <label class="cursor text-underline ft-12"
          (click)="register()"><u>Sign
            Up</u></label> </div>
    </div>
  </div>
</div>